import { render, staticRenderFns } from "./IpDeleteModal.vue?vue&type=template&id=4f576293&"
import script from "./IpDeleteModal.vue?vue&type=script&lang=js&"
export * from "./IpDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports